import { defineStore } from "pinia";

export const useUI = defineStore("ui", {
  state: () => {
    return {
      breakpoint: null,
      verticalBreakpoint: null,
      // These breakpoints should be adapted to the current library being used
      // Brakpoints defined by their minimum boundary
      breakpoints: {
        xs: -Infinity,
        sm: 640,
        md: 768,
        lg: 1024,
        xl: 1280,
        "2xl": 1536,
      },
      verticalBreakpoints: {
        xs: -Infinity,
        sm: 375,
        md: 520,
        lg: 640,
        xl: 1080,
        "2xl": 1200,
      },
    };
  },
  actions: {
    getBreakpoint() {
      let found = null;
      let verticalFound = null;
      const width = window.innerWidth;
      const height = window.innerHeight;
      const map = this.breakpoints;
      Object.entries(map).forEach(([name, size]) => {
        if (width > size) found = name;
      });
      const verticalMap = this.verticalBreakpoints;
      Object.entries(verticalMap).forEach(([name, size]) => {
        if (height > size) verticalFound = name;
      });
      this.breakpoint = found;
      this.verticalBreakpoint = verticalFound;
      return found;
    },
  },
  getters: {
    currentBreakPointIsLowerThan: (state) => (reference) => {
      if (state.breakpoint) {
        return state.breakpoints[state.breakpoint] < state.breakpoints[reference];
      }
      return false;
    },
    currentBreakPointIsHigherThan: (state) => (reference) => {
      if (state.breakpoint) {
        return state.breakpoints[state.breakpoint] > state.breakpoints[reference];
      }
      return false;
    },
    currentVerticalBreakPointIsLowerThan: (state) => (reference) => {
      if (state.verticalBreakpoint) {
        return (
          state.verticalBreakpoints[state.verticalBreakpoint] < state.verticalBreakpoints[reference]
        );
      }
      return false;
    },
    currentVerticalBreakPointIsHigherThan: (state) => (reference) => {
      if (state.verticalBreakpoint) {
        return (
          state.verticalBreakpoints[state.verticalBreakpoint] > state.verticalBreakpoints[reference]
        );
      }
      return false;
    },
  },
});
